export default __webpack_public_path__ + "static/media/pantry2-after2-1440w.2fd8ab12.avif";